import getCountryCodes from '../../translations/countryCodes';

/**
 * Turn an ISO 3166-1 alpha-2 code into a country name in the current locale.
 *
 * Extracted when a third copy appeared. CL-SHIP-01 wrote it in ShippingInfo, then
 * CL-STOCK-01 needed the same lookup in StockLocationSelect and again in
 * EditListingDeliveryForm — and that third one is a base template file, so the
 * duplication was also widening the surface a future upstream merge has to touch.
 *
 * The map is built once per locale at module scope, not per render: ShippingInfo can
 * render twice on a single listing page once OrderPanel renders it too.
 *
 * Always store and compare the CODE. Only ever show the name (SL2).
 */
const countryNameMapCache = {};

const countryNameMapFor = locale => {
  if (!countryNameMapCache[locale]) {
    const map = {};
    getCountryCodes(locale).forEach(({ code, name }) => {
      map[code] = name;
    });
    countryNameMapCache[locale] = map;
  }
  return countryNameMapCache[locale];
};

/**
 * @param {string|null} countryCode - ISO 3166-1 alpha-2, e.g. 'US'
 * @param {string} locale - e.g. 'en'
 * @returns {string|null} the localised name, the code itself if unknown, null if no code
 */
export const countryNameFor = (countryCode, locale) => {
  if (!countryCode) return null;
  return countryNameMapFor(locale)[countryCode] || countryCode;
};
